import { useState } from "react";
import { NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";

import image1 from "../img/utpl.png";

function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="w-full bg-[#004270] shadow-md fixed top-0 left-0 z-50">
      <div className="max-w-6xl mx-auto px-4 py-3 flex justify-between items-center">
        
        {/* Logo */}
        <NavLink to="/" className="flex items-center">
          <img src={image1} alt="utpl" className="h-8" />
        </NavLink>

        {/* Desktop Menu */}
        <nav className="hidden md:flex items-center gap-8">
          <a href="#inicio" className="hover:text-blue-600 transition">
            Inicio
          </a>
          <a href="#simposios" className="hover:text-blue-600 transition">
            Simposios
          </a>
          <a href="#ponentes" className="hover:text-blue-600 transition">
            Ponentes
          </a>

          {/* Botón destacado */}
          <a
            href="#participar"
            className="bg-blue-600 text-white px-5 py-2 rounded-xl font-semibold hover:bg-blue-700 transition shadow-md"
          >
            Participar
          </a>
        </nav>

        {/* Mobile Button */}
        <button
          className="md:hidden text-white"
          onClick={() => setOpen(!open)}
        >
          {open ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden bg-[#004270] transition-all duration-300 overflow-hidden ${
          open ? "max-h-96 py-4" : "max-h-0"
        }`}
      >
        <div className="flex flex-col items-center gap-6">
          <a href="#inicio" onClick={() => setOpen(false)}>
            Inicio
          </a>
          <a href="#simposios" onClick={() => setOpen(false)}>
            Simposios
          </a>
          <a href="#ponentes" onClick={() => setOpen(false)}>
            Ponentes
          </a>

          {/* Botón destacado móvil */}
          <a
            href="#participar"
            onClick={() => setOpen(false)}
            className="bg-blue-600 text-white px-6 py-2 rounded-xl font-semibold shadow-md"
          >
            Participar
          </a>
        </div>
      </div>
    </header>
  );
}

export default Header;